import { STATUS } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, "bg-slate-100 text-slate-700 border-slate-300"];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${cls}`}>
      {label}
    </span>
  );
};

export const PageHeader = ({ kicker, title, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {kicker && <p className="mb-1 text-xs font-semibold uppercase tracking-[0.2em] text-red-600">{kicker}</p>}
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const StatCard = ({ label, value, icon: Icon, accent = "#1E3A8A", testId }) => (
  <div data-testid={testId} className="relative overflow-hidden rounded-md border border-slate-200 bg-white p-5 transition-transform duration-200 hover:-translate-y-0.5">
    <div className="absolute left-0 top-0 h-full w-1" style={{ background: accent }} />
    <div className="flex items-start justify-between">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      {Icon && <Icon className="h-4 w-4" style={{ color: accent }} />}
    </div>
    <p className="mt-3 font-display text-2xl font-bold text-slate-900">{value}</p>
  </div>
);

export const NSelect = ({ value, onChange, children, testId, className = "" }) => (
  <select
    data-testid={testId}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    className={`h-9 w-full rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-800/30 ${className}`}
  >
    {children}
  </select>
);

export const Field = ({ label, children, className = "" }) => (
  <label className={`block space-y-1.5 ${className}`}>
    <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    {children}
  </label>
);

export const Empty = ({ text, testId }) => (
  <div data-testid={testId} className="rounded-md border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500">
    {text}
  </div>
);

export const Panel = ({ title, children, action, className = "" }) => (
  <section className={`rounded-md border border-slate-200 bg-white ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
        <h2 className="font-display text-base font-semibold text-slate-900">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const TableWrap = ({ children }) => (
  <div className="overflow-x-auto rounded-md border border-slate-200 bg-white">
    <table className="w-full text-sm">{children}</table>
  </div>
);

export const Th = ({ children, className = "" }) => (
  <th className={`border-b border-slate-200 bg-slate-50 px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500 ${className}`}>{children}</th>
);

export const Td = ({ children, className = "" }) => <td className={`border-b border-slate-100 px-4 py-3 ${className}`}>{children}</td>;
